import script from "./R06View.vue?vue&type=script&setup=true&lang=ts"
export * from "./R06View.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__